/**
 * /app/{slug}/hr/offboarding — Offboarding hub (Cycles section).
 *
 * Cycles + Letters are sister sub-routes (SOP §1.4 — page-internal
 * Sub-route Tabs pattern). The pattern is documented in
 * `components/shared/sub-route-tabs.tsx`; this file is the Cycles
 * landing.
 *
 * History:
 *  - Phase 3f (2026-06-01) — initially ported with internal Tabs +
 *    `?tab=cycles|letters` query state (single page, content swap).
 *  - 2026-06-04 — SOP §1.4 introduced. Cycles + Letters split into
 *    real sub-routes because they have different data shapes
 *    (transactional cycles vs the tenant letter template library).
 *    Visual continuity preserved by the new `<SubRouteTabs>`
 *    primitive — identical pill-on-muted look as shadcn `<Tabs>`,
 *    but each "tab" is a real `<Link>`. No more `?tab=` query
 *    state; URL alone identifies the section.
 */

import { createFileRoute, useParams } from "@tanstack/react-router";
import { HrModuleShell } from "@/components/shared/hr-module-shell";
import { OffboardingRoleGate } from "@/components/offboarding/offboarding-role-gate";
import { CyclesTab } from "@/components/offboarding/cycles-tab";
import { ResignationsPanel } from "@/components/offboarding/resignations-panel";
import { OffboardingSubRouteTabs } from "@/components/offboarding/sub-route-tabs";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/hr/offboarding/")({
  component: OffboardingCyclesRoute,
});

function OffboardingCyclesRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };

  return (
    <HrModuleShell
      title="Exits"
      description="Track every employee exit: cycles, F&F, and letters."
    >
      <OffboardingRoleGate>
        <OffboardingSubRouteTabs tenantSlug={tenantSlug} className="mb-4" />
        <ResignationsPanel />
        <CyclesTab />
      </OffboardingRoleGate>
    </HrModuleShell>
  );
}
